import script from "./detail-sidebar.vue?vue&type=script&setup=true&lang=js"
export * from "./detail-sidebar.vue?vue&type=script&setup=true&lang=js"

import "./detail-sidebar.vue?vue&type=style&index=0&id=8621a4c2&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8621a4c2"]])

export default __exports__